import { Query } from "@apollo/client/react/components";
import { Loader } from "@govlaunch/core";
import React from "react";
import { useSelfie } from "~/components/auth/Auth";
import GatedContent from "~/components/GatedContent";
import Group from "~/components/group/Group";
import GroupQuery from "~/lib/queries/GroupQuery";
import { IGroupQuery, IGroupQueryVariables } from "~/lib/queries/__generated__/GroupQuery.generated";
import Redirect from "~/lib/route/Redirect";
import isVerifiedUser from "~/lib/utils/isVerifiedUser";
import safeGetQueryParameter from "~/lib/utils/safeGetQueryParameter";
import NavbarLayout from "~/src/components/navbar/NavbarLayout";

interface IGroupPageProps {
  slug: string;
  projectSlug?: string;
  content?: string;
  feedLimit?: number;
  token?: string;
  redirectTo?: string;
}

export default function GroupPage({ slug, projectSlug, token, redirectTo, content }: IGroupPageProps) {
  const user = useSelfie();

  if (token) {
    return <Redirect to={`/signin?token=${token}&redirectTo=${redirectTo}`} />;
  }

  if (!isVerifiedUser(user)) {
    return (
      <NavbarLayout>
        <GatedContent hardRefreshAfterSignin={true} image="/static/gating/government-desktop.png" />
      </NavbarLayout>
    );
  }

  return (
    <Query<IGroupQuery, IGroupQueryVariables>
      query={GroupQuery}
      variables={{
        slug,
      }}
    >
      {({ data, loading }) => {
        if (token) {
          return <Redirect to={`/signin?token=${token}&redirectTo=${redirectTo}`} />;
        }

        if (loading) {
          return (
            <div css={{ padding: "48px 0" }}>
              <Loader centered={true} />
            </div>
          );
        }

        if (!data || !data.groupBySlug) {
          return <Redirect to="/" />;
        }

        const { groupBySlug: group } = data;

        return (
          <NavbarLayout>
            <Group group={group} projectSlug={projectSlug} content={content as any} />
          </NavbarLayout>
        );
      }}
    </Query>
  );
}

GroupPage.getInitialProps = ({ query }: any) => {
  return {
    slug: safeGetQueryParameter(query, "groupSlug"),
    projectSlug: safeGetQueryParameter(query, "projectSlug"),
    content: safeGetQueryParameter(query, "content"),
    feedLimit: Number(safeGetQueryParameter(query, "feedLimit")),
    token: safeGetQueryParameter(query, "token"),
    redirectTo: safeGetQueryParameter(query, "redirectTo"),
  };
};
